/**
 * This hook returns some values ​​from various queries that are deprecated but currently have no alternatives.
 * The metadata for the event and the master event must be expanded to contain the selected values ​​for this hook to be removed.
 * 
 * P.S. Master event request exists, but is not yet integrated
 */

import { useGetEventCoursesQuery } from "../../../api/alaskaApi"

const useMissingData = ({ eventId }: { eventId: number | null }) => {
  const { data: courses } = useGetEventCoursesQuery(eventId ?? -1, {
    skip: !eventId,
  })

  return { ctLiveRegLink: courses?.CTLiveRegistrationLink }
}

export { useMissingData }